<template>
  <div>
    <template v-for="product in giveAwayProducts">
      <v-layout :key="product.id" style="align-items: center">
        <v-flex shrink class="pa-1">
          <img
            :src="
              product.photourl
                ? product.photourl.split(';;')[0]
                : require(`@/assets/img/products/default-photo.png`)
            "
            alt="product.name"
            class="grey lighten-2"
            lazy
            aspect-ratio="1"
            style="max-width: 50px"
            @error="onImageError"
          />
        </v-flex>
        <v-flex>
          {{ product.name || '-' }}
          <template v-if="product.option">({{ product.option }})</template>
          x {{ product.quantity }}
        </v-flex>
        <v-flex shrink>
          <v-btn
            :outline="!(value && product.productid == value.productid)"
            :color="
              value && product.productid == value.productid ? 'primary' : ''
            "
            @click="handleSelectGiveAwayProduct(product)"
            depressed
            >{{
              value && product.productid == value.productid
                ? $t('selected')
                : $t('Select')
            }}</v-btn
          >
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
export default {
  props: ['value', 'giveAwayProducts'],
  methods: {
    onImageError(error) {
      //   error.target.src = `@/assets/img/products/default-photo.png`
    },
    handleSelectGiveAwayProduct(item) {
      if (this.value) {
        if (this.value.productid == item.productid) {
          this.$emit('handleSelectGiveAwayProduct', null)
          return false
        }
      }
      this.$emit('handleSelectGiveAwayProduct', item)
    }
  }
}
</script>

<style lang="scss" scoped></style>
